import React from "react";
import {
    Card,
    CardBody,
    CardHeader,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const RevenueReport = () => {
    const popularMenus = [
        { label: 'Nâu đá', value: 60 },
        { label: 'Sữa chua', value: 50 },
        { label: 'Sữa tươi', value: 45 },
        { label: 'Nước chanh', value: 40 },
        { label: 'Sữa dừa', value: 40 },
        { label: 'Cà phê sữa', value: 35 },
        { label: 'Cà phê đen', value: 30 },
        { label: 'Sữa bò', value: 30 },
    ];

    const averagePrepTimes = [
        { label: 'Nâu đá', value: 3 },
        { label: 'Sữa chua', value: 5 },
        { label: 'Sữa tươi', value: 4 },
        { label: 'Nước chanh', value: 4 },
        { label: 'Sữa dừa', value: 4 },
        { label: 'Cà phê sữa', value: 5 },
        { label: 'Cà phê đen', value: 3 },
        { label: 'Sữa bò', value: 3 },
    ];

    const createSeries = (data: { value: number }[]) => [
        {
            name: 'Sessions',
            data: data.map(item => item.value),
        },
    ];

    const createOptions = (categories: string[]): ApexOptions => ({
        chart: {
            type: 'bar',
            height: 436,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                distributed: false,  // Chỉ dùng một màu duy nhất
                dataLabels: {
                    position: 'top',
                },
            }
        },
        colors: ['#007bff'], // Sử dụng một màu duy nhất (có thể đổi nếu cần)
        dataLabels: {
            enabled: true,
            offsetX: 32,
            style: {
                fontSize: '12px',
                fontWeight: 400,
                colors: ['#adb5bd']
            }
        },
        legend: { show: false },
        grid: { show: false },
        xaxis: {
            categories,
        },
    });

    const series = createSeries(popularMenus);
    const series1 = createSeries(averagePrepTimes);
    const menuOptions = createOptions(popularMenus.map(item => item.label));
    const avgTimeOptions = createOptions(averagePrepTimes.map(item => item.label));

    return (
        <React.Fragment>
            <div className="page-content-wrapper py-3">
                <div className="container">
                    <Card>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1">Số lượng món</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Hôm nay</DropdownItem>
                                            <DropdownItem href="#">Tuần này</DropdownItem>
                                            <DropdownItem href="#">Tuần trước</DropdownItem>
                                            <DropdownItem href="#">7 ngày qua</DropdownItem>
                                            <DropdownItem href="#">Tháng này</DropdownItem>
                                            <DropdownItem href="#">Tháng trước</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart dir="ltr"
                                options={menuOptions}
                                series={series}
                                type="bar"
                                height="436"
                                className="apex-charts"
                            />
                        </CardBody>
                    </Card>
                    <Card className={"mt-2"}>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1">Thời gian trung bình</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Hôm nay</DropdownItem>
                                            <DropdownItem href="#">Tuần này</DropdownItem>
                                            <DropdownItem href="#">Tuần trước</DropdownItem>
                                            <DropdownItem href="#">7 ngày qua</DropdownItem>
                                            <DropdownItem href="#">Tháng này</DropdownItem>
                                            <DropdownItem href="#">Tháng trước</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart dir="ltr"
                                options={avgTimeOptions}
                                series={series1}
                                type="bar"
                                height="436"
                                className="apex-charts"
                            />
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default RevenueReport;
